import React from "react";

const LokasiCell = ({ text, maxLength = 30 }) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!text) return <span>-</span>;

  const isLong = text.length > maxLength;
  const displayText =
    expanded || !isLong ? text : text.substring(0, maxLength) + "...";

  return (
    <div style={{ wordBreak: "break-word" }}>
      {displayText}{" "}
      {isLong && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "#1976d2",
            cursor: "pointer",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {expanded ? "Baca Sedikit" : "Baca Banyak"}
        </span>
      )}
    </div>
  );
};

export default LokasiCell;
